import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Heading } from 'blaze-ui/Heading/Heading'
import { observer } from 'mobx-react-lite'
import { DayTimeSelector } from './CustomSchedule/DayTimeSelector'
import { TimeOfDay, CustomTime } from './types'

interface DayTimeSelectorDrawerProps extends DrawerProps {
  selectedDay: string
  currentSelection: TimeOfDay
  currentCustomTime?: CustomTime
  onSave: (timeType: TimeOfDay, customTime?: CustomTime) => void
  onBack: () => void
}

export const DayTimeSelectorDrawer = observer(
  ({
    selectedDay,
    currentSelection,
    currentCustomTime,
    onSave,
    onBack,
    ...drawerProps
  }: DayTimeSelectorDrawerProps) => {
    return (
      <Drawer.Root {...drawerProps}>
        <Drawer.Portal>
          <Drawer.Overlay />
          <Drawer.Content fullHeight>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Top>
                <Drawer.Back onPress={onBack} />
                <Drawer.Title asChild>
                  <Heading level={5}>Edit {selectedDay} Post Time</Heading>
                </Drawer.Title>
                <Drawer.Close position="right" />
              </Drawer.Top>
              <Drawer.Container>
                <DayTimeSelector
                  selectedDay={selectedDay}
                  currentSelection={currentSelection}
                  currentCustomTime={currentCustomTime}
                  onSave={onSave}
                  onBack={onBack}
                />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
